import { render, staticRenderFns } from "./MiniSalesOrders.vue?vue&type=template&id=7db2462a&scoped=true"
import script from "./MiniSalesOrders.vue?vue&type=script&lang=js"
export * from "./MiniSalesOrders.vue?vue&type=script&lang=js"
import style0 from "./MiniSalesOrders.vue?vue&type=style&index=0&id=7db2462a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db2462a",
  null
  
)

export default component.exports